module.exports = __webpack_public_path__ + "media/pages/assets/images/mapc-logo-81dcc82b86b2da835a08b8d347d9e2ec.svg";